import apiClient from './client';

export const userService = {
    // Get all users (DG only)
    async getAllUsers() {
        return await apiClient('users');
    },

    // Get user details and history (DG only)
    async getUserDetail(userId, params = {}) {
        let queryString = '';
        if (Object.keys(params).length > 0) {
            queryString = '?' + new URLSearchParams(params).toString();
        }
        return await apiClient(`dg/users/${encodeURIComponent(userId)}${queryString}`);
    }
};
